// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `notice/index${i + 1}`,
  name: `noticeIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/notice/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
